import { FormEvent, useState } from 'react';
import { generateDate } from '../../../helpers';
import { usePublication } from '../../../hooks/usePublication';

interface Props {
    isOpen: boolean;
    handleCloseReport: () => void;
    idRecurso: string | undefined
}

export const ReportErrorForm = ({ isOpen, handleCloseReport, idRecurso }: Props) => {
  const [typeError, setTypeError] = useState('1');
  const [description, setDescription] = useState('');
  const [informantEmail, setInformantEmail] = useState('');
  const [isSendReport, setIsSendReport] = useState(false);
  const {publication} = usePublication();

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) =>{
    e.preventDefault();
    setIsSendReport(true);
    const errorData = {
        nombreRecurso: publication.title,
        idRecurso: idRecurso,
        tipo_recurso: 'lib',
        fecha_reporte: generateDate(),
        reportado_por: informantEmail,
        // tipo_error_id: Number(typeError), //TODO: Se debe agregar cuando existan mas códigos de error
        tipo_error_id: 1,
        descripcion_error: `idRecurso: ${idRecurso} `+description
    }

    const data = await fetch('https://apivirtualplant.com/apiVpro/public/api/errors/save', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(errorData)
    }).then((res) => res.json());

    if(data.error){
        return;
    }

    //TODO: Hacer algo cuando se envía correctamente
    handleCloseReport();
    setIsSendReport(false);
    setDescription('');
    setInformantEmail('');
  }

  return (
    <div id="subc-3" className={`sub-content__content ${isOpen?"xpand":""}`}> 
        <form onSubmit={handleSubmit}>
            <div className="sub-content__actions">
                <button
                    type="button"
                    className="sub-button"
                    data-subc="subc-3"
                    aria-label="Cerrar ventana de reporte de errores"
                    onClick = { handleCloseReport }
                >
                    <span className="sub-button__icon">
                        <i className="icon icon-vpro-chevron-down"/>
                    </span>
                </button>
            </div>

            
            <div className="select-dd">
                <select
                    name="capitulos"
                    id="report-select"
                    className="select-dd__select"
                    value={typeError}
                    onChange={(e) => setTypeError(e.target.value)}
                >
                    <option value={0}>Error de contenido</option>
                    <option value={1}>Error de interface</option>
                    <option value={2}>Sugerencia</option>
                </select>
                <span className="select-dd__arrow"></span>
            </div>

            <div className="select-dd">
                <input
                    className="select-dd__select"
                    type="email"
                    value={informantEmail}
                    onChange={(e) => setInformantEmail(e.target.value)}
                    placeholder='ejemplo@ejemplo.com'/>
            </div>

            <textarea
                name=""
                id="txtAreaReport"
                className="txt-area"
                cols={30}
                rows={10}
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                placeholder="Por favor describa su caso"
            ></textarea>

            <button type="submit" className={`btn btn-alt-secondary btn--fw ${isSendReport ? 'sent' : ''}`}>
                <span className="btn__label">{isSendReport ? 'Reporte enviado' : 'Reportar'}</span>
            </button>
        </form>

    </div>
  )
}